module.exports = __webpack_public_path__ + "static/media/footy_bytes.4adf2200.png";